import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#ff85a2' }, // Muted pink
    secondary: { main: '#77dd77' }, // Softer green
    background: {
      default: '#121212', // Deep charcoal
      paper: '#1f1a24',   // Slightly lighter purple-black
      card: '#2a2139',    // Deep purple for cards
      hover: '#32283f',   // Muted purple-gray for hover effects
      border: '#4e445a',  // Soft gray for subtle borders
    },
    text: {
      primary: '#ffffff', // High contrast white
      secondary: '#b3a8c5', // Light gray
    },
  },
  typography: {
    fontSize: 12,
    datePicker: '0.875rem',
    body1: { fontSize: '0.85rem' },
    body2: { fontSize: '0.8rem' },
    button: { fontSize: '0.8rem', textTransform: 'none' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: '#4e445a #1f1a24',
        },
        '*::-webkit-scrollbar': { width: '8px' },
        '*::-webkit-scrollbar-track': { background: '#1f1a24' },
        '*::-webkit-scrollbar-thumb': {
          background: '#ff85a2',
          borderRadius: '0', // 🔥 Square scrollbar thumb
        },
        '*::-webkit-scrollbar-thumb:hover': { background: '#77dd77' },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1f1a24',
          border: '1px solid #292929',
          borderRadius: 0, // 🔥 No rounded edges
        },
        listbox: {
          backgroundColor: '#1f1a24',
          borderRadius: 0, // 🔥 Square dropdown list
        },
      },
    },
    MuiSelect: {
        styleOverrides: {
          root: {
            fontSize: '0.85rem',
            backgroundColor: '#2a2139',
            color: '#ffffff',
            borderRadius: 0, // 🔥 Square edges
            borderWidth: '1px', // ✅ Ensures border width does not change
            '&:hover, &:focus': {
              border: '1px solid #4e445a', // ✅ No highlight effect
              borderWidth: '1px', // ✅ Prevents border from getting thicker
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 0, // 🔥 Square input fields
            borderWidth: '1px', // ✅ Ensures border stays same thickness
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(255, 255, 255, 0.2)', // ✅ No border highlight on hover
              borderWidth: '1px', // ✅ Keeps border width the same
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(255, 255, 255, 0.2)', // ✅ No focus highlight
              borderWidth: '1px', // ✅ Keeps border width the same
            },
          },
          notchedOutline: {
            borderColor: 'rgba(255, 255, 255, 0.2)', // ✅ No border highlight
            borderWidth: '1px', // ✅ Keeps border width the same
          },
        },
      },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '0.85rem',
          backgroundColor: '#1f1a24',
          color: '#ffffff',
          borderRadius: 0, // 🔥 Square menu items
          '&:hover': { backgroundColor: '#32283f' },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: '0.8rem',
          borderRadius: 0, // 🔥 Square chips
          backgroundColor: '#2a2139',
          color: '#ffffff',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#32283f',
          color: '#ffffff',
          borderRadius: 0, // 🔥 Square buttons
          '&:hover': { backgroundColor: '#4e445a' },
        },
      },
    },
    MuiCard: {
        styleOverrides: {
          root: {
            backgroundColor: "#121212 !important", // ✅ Prevents any inherited color
            border: "none", // ✅ Removes any default light borders
            color: "inherit", // ✅ Ensures it uses the parent text color
          },
        },
      },
      MuiCardContent: {
        styleOverrides: {
          root: {
            backgroundColor: "#121212 !important", // 🔥 Prevents inner CardContent color from showing
            padding: "16px", // ✅ Keeps padding but removes any white background effect
          },
        },
      },
      MuiGrid: {
        styleOverrides: {
          root: {
            backgroundColor: "#121212 !important",
            color: "inherit",
          },
        },
      },
  },
});

export default theme;
